/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a36cafb0c6caf337985ead5fbe9105acec712ee7";
